import { WEBSITES, WebsiteTenantDef } from "providers/ServerSideProps/consts";
import { SessionData } from "providers/Session";
import React, { createContext } from "react";

export type ServerSidePropsContextType = {
  article: Array<any>;
  domain: string;
  navigation: {
    menuActions: Array<any>;
    menuSide: Array<any>;
    menuTop: Array<any>;
  };
  page: {
    id: string;
    color: string;
    extid: string;
    name: string;
    pageKeywords: string;
    pageMetadata: string;
    pageTemplate: string;
    pageTitle: string;
    hidePageTitle: boolean;
    path: string;
    pathSegment: string;
    type: string;
    pageConfig: {
      featureRadioSelectPaywall: string;
      featureToggleCacheResync: boolean;
      featureToggleMostRead: boolean;
      featureTogglePaywall: boolean;
      featureTogglePushNews: boolean;
      featureToggleFolhaPress: boolean;
      featureToggleHoroscope: boolean;
      featureToggleCapinha: boolean;
      featureToggleSitemap: boolean;
    };
    pageSocialData: {
      facebookAppId: string;
      facebookPageId: string;
      twitterContentCreator: string;
      twitterSiteCreator: string;
    };
    fieldSubscriptionPrice: string;
  };
  deviceType?: string;
  pageSlots: {
    p1g1slot1list: Array<string>;
    p1g1slot2list: Array<string>;
    p1g2slot1list: Array<string>;
    p1g2slot2list: Array<string>;
    p1g3slot1list: Array<string>;
    p1g3slot2list: Array<string>;
    p1g4slot1list: Array<string>;
    p1g4slot2list: Array<string>;
    p2g1slot1list: Array<string>;
    p2g1slot2list: Array<string>;
    p2g2slot1list: Array<string>;
    p2g2slot2list: Array<string>;
    p2g3slot1list: Array<string>;
    p2g3slot2list: Array<string>;
    p2g4slot1list: Array<string>;
    p2g4slot2list: Array<string>;
    p3g1slot1list: Array<string>;
    p3g1slot2list: Array<string>;
    p3g2slot1list: Array<string>;
    p3g2slot2list: Array<string>;
    p3g3slot1list: Array<string>;
    p3g3slot2list: Array<string>;
    p3g4slot1list: Array<string>;
    p3g4slot2list: Array<string>;
  };
  pageType: {
    type: string;
    departmentSlug: string;
  };
  site: {
    id: string;
    color: string;
    extid: string;
    name: string;
    pageKeywords: string;
    pageMetadata: string;
    pageTemplate: string;
    pageTitle: string;
    hidePageTitle: boolean;
    path: string;
    pathSegment: string;
    type: string;
    pageConfig: {
      featureRadioSelectPaywall: string;
      featureToggleCacheResync: boolean;
      featureToggleMostRead: boolean;
      featureTogglePaywall: boolean;
      featureTogglePushNews: boolean;
      featureToggleFolhaPress: boolean;
      featureToggleHoroscope: boolean;
      featureToggleCapinha: boolean;
      featureToggleSitemap: boolean;
    };
    pageSocialData: {
      facebookAppId: string;
      facebookPageId: string;
      twitterContentCreator: string;
      twitterSiteCreator: string;
    };
    fieldSubscriptionPrice: string;
    siteDomain: string;
  };
  siteSlots: {
    p1g1slot1list: Array<string>;
    p1g1slot2list: Array<string>;
    p1g2slot1list: Array<string>;
    p1g2slot2list: Array<string>;
    p1g3slot1list: Array<string>;
    p1g3slot2list: Array<string>;
    p1g4slot1list: Array<string>;
    p1g4slot2list: Array<string>;
    p2g1slot1list: Array<string>;
    p2g1slot2list: Array<string>;
    p2g2slot1list: Array<string>;
    p2g2slot2list: Array<string>;
    p2g3slot1list: Array<string>;
    p2g3slot2list: Array<string>;
    p2g4slot1list: Array<string>;
    p2g4slot2list: Array<string>;
    p3g1slot1list: Array<string>;
    p3g1slot2list: Array<string>;
    p3g2slot1list: Array<string>;
    p3g2slot2list: Array<string>;
    p3g3slot1list: Array<string>;
    p3g3slot2list: Array<string>;
    p3g4slot1list: Array<string>;
    p3g4slot2list: Array<string>;
  };
  siteSlug: string;
  session: SessionData;
  siteConfig: WebsiteTenantDef;
};

export type ServerSidePropsStateType = {
  article: Array<any>;
  domain: string;
  navigation: {
    menuActions: Array<any>;
    menuSide: Array<any>;
    menuTop: Array<any>;
  };
  page: {
    id: string;
    color: string;
    extid: string;
    name: string;
    pageKeywords: string;
    pageMetadata: string;
    pageTemplate: string;
    pageTitle: string;
    hidePageTitle: boolean;
    path: string;
    pathSegment: string;
    type: string;
    pageConfig: {
      featureRadioSelectPaywall: string;
      featureToggleCacheResync: boolean;
      featureToggleMostRead: boolean;
      featureTogglePaywall: boolean;
      featureTogglePushNews: boolean;
      featureToggleFolhaPress: boolean;
      featureToggleHoroscope: boolean;
      featureToggleCapinha: boolean;
      featureToggleSitemap: boolean;
    };
    deviceType?: string;
    pageSocialData: {
      facebookAppId: string;
      facebookPageId: string;
      twitterContentCreator: string;
      twitterSiteCreator: string;
    };
    fieldSubscriptionPrice: string;
  };
  pageSlots: {
    p1g1slot1list: Array<string>;
    p1g1slot2list: Array<string>;
    p1g2slot1list: Array<string>;
    p1g2slot2list: Array<string>;
    p1g3slot1list: Array<string>;
    p1g3slot2list: Array<string>;
    p1g4slot1list: Array<string>;
    p1g4slot2list: Array<string>;
    p1g5slot1list: Array<string>;
    p1g5slot2list: Array<string>;
    p1g6slot1list: Array<string>;
    p1g6slot2list: Array<string>;
    p1g7slot1list: Array<string>;
    p1g7slot2list: Array<string>;
    p1g8slot1list: Array<string>;
    p1g8slot2list: Array<string>;
    p2g1slot1list: Array<string>;
    p2g1slot2list: Array<string>;
    p2g2slot1list: Array<string>;
    p2g2slot2list: Array<string>;
    p2g3slot1list: Array<string>;
    p2g3slot2list: Array<string>;
    p2g4slot1list: Array<string>;
    p2g4slot2list: Array<string>;
    p3g1slot1list: Array<string>;
    p3g1slot2list: Array<string>;
    p3g2slot1list: Array<string>;
    p3g2slot2list: Array<string>;
    p3g3slot1list: Array<string>;
    p3g3slot2list: Array<string>;
    p3g4slot1list: Array<string>;
    p3g4slot2list: Array<string>;
  };
  pageType: {
    type: string;
    departmentSlug: string;
  };
  site: {
    id: string;
    color: string;
    extid: string;
    name: string;
    pageKeywords: string;
    pageMetadata: string;
    pageTemplate: string;
    pageTitle: string;
    hidePageTitle: boolean;
    path: string;
    pathSegment: string;
    type: string;
    pageConfig: {
      featureRadioSelectPaywall: string;
      featureToggleCacheResync: boolean;
      featureToggleMostRead: boolean;
      featureTogglePaywall: boolean;
      featureTogglePushNews: boolean;
      featureToggleFolhaPress: boolean;
      featureToggleHoroscope: boolean;
      featureToggleCapinha: boolean;
      featureToggleSitemap: boolean;
    };
    pageSocialData: {
      facebookAppId: string;
      facebookPageId: string;
      twitterContentCreator: string;
      twitterSiteCreator: string;
    };
    fieldSubscriptionPrice: string;
    siteDomain: string;
  };
  siteSlots: {
    p1g1slot1list: Array<string>;
    p1g1slot2list: Array<string>;
    p1g2slot1list: Array<string>;
    p1g2slot2list: Array<string>;
    p1g3slot1list: Array<string>;
    p1g3slot2list: Array<string>;
    p1g4slot1list: Array<string>;
    p1g4slot2list: Array<string>;
    p1g5slot1list: Array<string>;
    p1g5slot2list: Array<string>;
    p1g6slot1list: Array<string>;
    p1g6slot2list: Array<string>;
    p1g7slot1list: Array<string>;
    p1g7slot2list: Array<string>;
    p1g8slot1list: Array<string>;
    p1g8slot2list: Array<string>;
    p2g1slot1list: Array<string>;
    p2g1slot2list: Array<string>;
    p2g2slot1list: Array<string>;
    p2g2slot2list: Array<string>;
    p2g3slot1list: Array<string>;
    p2g3slot2list: Array<string>;
    p2g4slot1list: Array<string>;
    p2g4slot2list: Array<string>;
    p3g1slot1list: Array<string>;
    p3g1slot2list: Array<string>;
    p3g2slot1list: Array<string>;
    p3g2slot2list: Array<string>;
    p3g3slot1list: Array<string>;
    p3g3slot2list: Array<string>;
    p3g4slot1list: Array<string>;
    p3g4slot2list: Array<string>;
  };
  siteSlug: string;
  session: SessionData;
};

export interface ServerSidePropsProvider {
  children: any;
  serverSideData: ServerSidePropsStateType;
}

export const ServerSidePropsContext = createContext<ServerSidePropsContextType>(
  {} as ServerSidePropsContextType
);

const ServerSideDataProvider: React.FC<ServerSidePropsProvider> = (props) => {
  const environmentSlug = process.env.NEXT_PUBLIC_WEBAPP_CLIENT_SLUG;
  const selectedSite =
    WEBSITES.find((i) => i.slug === props?.serverSideData?.siteSlug) ||
    WEBSITES.find((i) => i.slug === environmentSlug) ||
    WEBSITES[0];

  return (
    <ServerSidePropsContext.Provider
      value={{ ...props.serverSideData, siteConfig: selectedSite }}
    >
      {props.children}
    </ServerSidePropsContext.Provider>
  );
};

export default ServerSideDataProvider;
